export const ComplianceCheckForm = [
  {
    title: "1. Product and Packaging (up to 10 images)",
    fileFieldName: "packaging_image",
    docType: "images",
    remarkFieldName: "packagingImageRemark",
    reUploadFieldName: ["reviewer", "isReuploadPackagingImage"],
    reviewerRemarkFieldName: ["reviewer", "reviewerPackagingImageRemark"],
  },
  {
    title: "2. Business Licensing, Licensing Agreement",
    fileFieldName: "product_image",
    docType: "images",
    remarkFieldName: "productImageRemark",
    reUploadFieldName: ["reviewer", "isReuploadProductImage"],
    reviewerRemarkFieldName: ["reviewer", "reviewerProductImageRemark"],
  },

  {
    title: "3. Product Testing Report / EU Examination Certificate",
    fileFieldName: "test_report",
    docType: "document",
    remarkFieldName: "testReportRemark",
    documentLabel: "Documents",
    reUploadFieldName: ["reviewer", "isReuploadTestReport"],
    reviewerRemarkFieldName: ["reviewer", "reviewerTestReportRemark"],
  },
  {
    title:
      "4. Product functions & features (e.g. name, model number, feature, special function, etc)",
    remarkFieldName: "briefDescription",
    remarkLabel: "Descriptions",
    reUploadFieldName: ["reviewer", "isReuploadBriefDescription"],
    reviewerRemarkFieldName: ["reviewer", "reviewerBriefDescriptionRemark"],
  },
  {
    title:
      "5. List of components and materials used (Bill of materials / Bill of substances)",
    remarkFieldName: "materialsUsed",
    remarkLabel: "Descriptions",
    reUploadFieldName: ["reviewer", "isReuploadMaterialsUsed"],
    reviewerRemarkFieldName: ["reviewer", "reviewerMaterialsUsedRemark"],
  },
  {
    title: "6. Circuit diagram",
    fileFieldName: "circuit_diagram",
    docType: "document",
    remarkFieldName: "circuitDiagramRemark",
    documentLabel: "Documents",
    reUploadFieldName: ["reviewer", "isReuploadCircuitDiagram"],
    reviewerRemarkFieldName: ["reviewer", "reviewerCircuitDiagramRemark"],
  },
  {
    title: "7. Instruction manual",
    fileFieldName: "instruction_manual",
    docType: "document",
    remarkFieldName: "instructionManualRemark",
    documentLabel: "Documents",
    reUploadFieldName: ["reviewer", "isReuploadInstructionManual"],
    reviewerRemarkFieldName: ["reviewer", "reviewerInstructionManualRemark"],
  },
  {
    title: "8. Safety data sheet(s) for chemicals used",
    fileFieldName: "safety_data_sheet",
    docType: "document",
    remarkFieldName: "safetyDataSheetRemark",
    documentLabel: "Documents",
    reUploadFieldName: ["reviewer", "isReuploadSafetyDataSheet"],
    reviewerRemarkFieldName: ["reviewer", "reviewerSafetyDataSheetRemark"],
  },
  {
    title: "9. Ingredient list or formulation",
    fileFieldName: "ingredient_list",
    docType: "document",
    remarkFieldName: "ingredientListRemark",
    documentLabel: "Documents",
    reUploadFieldName: ["reviewer", "isReuploadIngredientList"],
    reviewerRemarkFieldName: ["reviewer", "reviewerIngredientListRemark"],
  },
  {
    title: "10. Manufacturer Information and Production Date Code",
    fileFieldName: "declaration_letter",
    docType: "document",
    remarkFieldName: "declarationLetterRemark",
    documentLabel: "Documents",
    reUploadFieldName: ["reviewer", "isReuploadDeclarationLetter"],
    reviewerRemarkFieldName: ["reviewer", "reviewerDeclarationLetterRemark"],
  },
  {
    title: "11. Conformity Certificate",
    fileFieldName: "conformity_certificate",
    docType: "document",
    remarkFieldName: "conformityCertificateRemark",
    documentLabel: "Documents",
    reUploadFieldName: ["reviewer", "isReloadConformityCertificate"],
    reviewerRemarkFieldName: [
      "reviewer",
      "reviewerConformityCertificateRemark",
    ],
    isConformityCertificate: true,
    hiddenRequireReupload: true,
  },
];
